"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.view = void 0;
var application_1 = require("../../models/application");
var ApplicationActions_1 = require("../../actions/ApplicationActions");
function view() {
    var _this = this;
    var preferredCommunicationMethodActions = new ApplicationActions_1.ApplicationWorkflowPreferredCommunicationMethodActions(this);
    return {
        state: {
            actionItem: this.props.actionItem,
        },
        initialize: function () {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        mounted: function () {
            _this.view.helpers.returnResultsToPage();
        },
        receivedProps: function (nextProps) {
            _this.view.state.actionItem = nextProps.actionItem;
            _this.view.helpers.returnResultsToPage();
            return new Promise(function (resolve) {
                resolve();
            });
        },
        unmount: function () { },
        events: {
            onPreferredCommunicationOptionsChange: function (preferredCommunication) {
                preferredCommunicationMethodActions.preferredCommunicationOptionsChanged(preferredCommunication);
                return false;
            },
        },
        helpers: {
            returnResultsToPage: function () {
                var resultData = new application_1.PreferredCommunicationResultData();
                resultData.actionId = _this.props.actionItem.id;
                resultData.integrationType = _this.props.actionItem.integrationType;
                resultData.type = application_1.ActionType.interviewIntegration;
                var preferredCommunicationVal = parseInt(_this.view.state.actionItem.preferredCommunicationOptions.value);
                resultData.preferredMethodOfCommunication = !isNaN(preferredCommunicationVal) ? preferredCommunicationVal : null;
                _this.props.onDataChanged(resultData);
            },
        },
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationWorkflowPreferredCommunicationMethod/View.js
// module id = 612
// module chunks = 0